import React, { useState, useEffect, useMemo } from 'react'
import { CoverImage } from 'sharedKernel/styledComponents/visualizationComponents/styles';
import { loggedUser } from 'sharedKernel/user/LoggedUser'
import { AccordionItem } from './AccordionItem';
import { faBookmark, faCircleInfo, faLaptop, faLightbulb, faMobileScreen, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { PageTitle } from './style';

const user = loggedUser.get();

const fallBackImage = require('../../../../../assets/images/HEADERS_TEIAPrefeituras.png')

const labels = {
    title: 'Bem-vindo(a) ao Programa Teia Prefeituras!',
    titleDescription: 'É um prazer receber seu município na Plataforma do Espaço Teia - Hub de Inovação da CAIXA.',
    laptopDescription: 'O que você encontra na Plataforma TEIA',
    bulbDescription: 'O que é o Programa TEIA Prefeituras?',
    groupDescription: 'Comunidade TEIA Prefeituras',
    bookmarkDescription: 'Próximos passos do seu município'
}

export const HubCompanyCityHallMain = (): JSX.Element => {

  return (
    <>
        <section>
            <PageTitle>
                <b>{labels.title}</b>
            </PageTitle>

            <p>
                {labels.titleDescription}
            </p>
        </section>

        <CoverImage backgroundImg={fallBackImage} />

        <AccordionItem title={labels.laptopDescription} icon={faLaptop}>
            <p>
                Este ambiente foi criado para apoiar sua gestão de forma prática e contínua.
                Aqui, seu município terá acesso a:
            </p>

            <ul>
                <li>Portfólio de Startups</li>
                <li>Calendário de Ativações e Eventos</li>
                <li>Conteúdos Estratégicos</li>
                <li>Materiais informativos, artigos, estudos de caso e insights sobre inovação pública.</li>
                <li>Chamadas e Oportunidades</li>
                <li>Informações sobre desafios, programas e iniciativas abertas para participação do município.</li>
            </ul>
        </AccordionItem>

        <AccordionItem title={labels.bulbDescription} icon={faLightbulb}>
            <p>
                Espaço de troca, aprendizado e conexão entre gestores públicos, especialistas
                e a equipe do Espaço TEIA.
            </p>
        </AccordionItem>

        <AccordionItem title={labels.groupDescription} icon={faUserGroup}>
            <p>
                O Programa foi estruturado para caminhar lado a lado com os municípios,
                respeitando seus desafios, prioridades e ritmo de maturidade, apoiando a sua
                agenda de inovação.
            </p>
        </AccordionItem>

        <AccordionItem title={labels.bookmarkDescription} icon={faBookmark}>
            <p>
                Para aproveitar plenamente a plataforma e o programa, orientamos:
            </p>

            <ul>
                <li>Conferir os dados institucionais do município</li>
                <li>Indicar os servidores que participarão do programa (até 5 representantes)</li>
                <li>Definir o ponto focal, que será o principal canal de relacionamento com o Espaço TEIA</li>
                <li>Acompanhar as ativações da fase de engajamento</li>
            </ul>
        </AccordionItem>

        <section style={{ marginTop: '20px' }}>
            <p>
                Conte com o Espaço TEIA
            </p>

            <p>
                O Espaço TEIA atua como parceiro estratégico dos municípios, oferecendo apoio técnico e institucional
                para transformar desafios públicos em soluções reais e escaláveis.
            </p>

            <p>
                Seja bem-vindo(a) à Comunidade TEIA Prefeituras.
            </p>
            <p>
                Vamos construir essa jornada juntos.
            </p>

            <p>
                Espaço TEIA | Hub de Inovação da CAIXA
            </p>
        </section>
    </>
  )
}